import moment from "moment";
import localization from "moment/locale/es";
import { decrypt, getsecret, secret } from "./crypt";

let mode;
let api_root;
let base = process.env.REACT_APP_API_URL;
if (base === undefined) {
  base = window.location.origin;
}
if (process.env.REACT_APP_NODE_ENV === "dev") {
  console.log("Dev environment, backend: http://dev.preciolonja.es");
  mode = "cors";
  api_root = "/api";
} else if (process.env.NODE_ENV === "production") {
  console.log("Production environment, backend: https://preciolonja.es");
  mode = "cors";
  api_root = "/api";
} else {
  console.log("Default environment, backend: http://localhost:80");
  mode = "cors";
  api_root = "";
}

const max_retries = 3;

function ISO8601_week_no(dt) {
  var tdt = new Date(dt.valueOf());
  var dayn = (dt.getDay() + 6) % 7;
  tdt.setDate(tdt.getDate() - dayn + 3);
  var firstThursday = tdt.valueOf();
  tdt.setMonth(0, 1);
  if (tdt.getDay() !== 4) {
    tdt.setMonth(0, 1 + ((4 - tdt.getDay() + 7) % 7));
  }
  var res = 1 + Math.ceil((firstThursday - tdt) / 604800000);
  return res;
}

function parseDate(date) {
  moment.updateLocale("es", localization);
  var parsedDate = new Date(date);
  var weekNumber = ISO8601_week_no(parsedDate);
  var week = `${weekNumber}º ${moment(date)
    .startOf("isoWeek")
    .format("DD")}-${moment(date).endOf("isoWeek").format("DD")}/${moment(
    date
  ).format("MM YYYY")}`;
  return week;
}

function nextweek(date, number) {
  const dates = [];
  let current = new Date(date);
  current = convertToStandard(current);
  for (let i = 0; i < number; i++) {
    console.log("Pushing", current);
    current.setUTCDate(current.getUTCDate() + 7);
    dates.push(convertToStandard(current));
  }
  return dates;
}

/* Return a list of  weeks between 2 dates */
function DatesBetween(begining, end) {
  const dates = [];
  let current = new Date(begining);
  current = convertToStandard(current);
  while (current <= end) {
    console.log("Pushing", current);
    dates.push(convertToStandard(current));
    current.setUTCDate(current.getUTCDate() + 7);
  }
  return dates;
}

/* Convert a date to standard time */
function convertToStandard(original) {
  let date = new Date(original);
  console.log("Converstion Date Start", date);
  date.setUTCHours(0);
  date.setUTCMinutes(0);
  date.setUTCSeconds(0);
  date.setUTCMilliseconds(0);
  var day = date.getDay(),
    diff = date.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
  const result = new Date(date.setUTCDate(diff));
  console.log("Converstion Date End", result);
  return result;
}

function getWeekDays(date) {
  const startOfWeek = moment(date).startOf("isoWeek");
  const endOfWeek = moment(date).endOf("isoWeek");

  const days = [];
  let day = startOfWeek;

  while (day <= endOfWeek) {
    days.push(day.toDate());
    day = day.clone().add(1, "d");
  }
  return days;
}

async function doGet(
  path,
  params,
  callback,
  encrypted = false,
  retries = 1,
  callback_error = null
) {
  const url = new URL(api_root + path, base);
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );
  try {
    let response = await fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: mode, // no-cors, *cors, same-origin
      credentials: "include", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *client
    });
    let json_answer = await response.json();
    if (json_answer.error != null) {
      if (json_answer.error === "authentication failed") {
        if (window.location.pathname !== "/overview") {
          window.location.href = "/";
        }
      }
      if (json_answer.error === "Session not established") {
        if (retries >= max_retries) {
          console.log("Error in the petition max_retries", json_answer.error);
        } else {
          console.log("Error in the petition, retrying", json_answer.error);
          getsecret(() => {
            doGet(path, params, callback, encrypted, ++retries).then();
          });
        }
      } else {
        console.log("Error in the petition", json_answer.error);
        if (callback_error != null) {
          callback_error(json_answer.error);
        }
      }
    } else {
      let data = json_answer.data;
      if (encrypted) {
        try {
          data = decrypt(data, secret);
          callback(data);
        } catch (err) {
          if (retries >= max_retries) {
            console.log("Unexpected error max_retries");
          } else {
            console.log("Unexpected error retrying", err);
            getsecret(() => {
              doGet(path, params, callback, encrypted, ++retries).then();
            });
          }
        }
      } else {
        callback(data);
      }
    }
  } catch (err) {
    console.log("Unexpected error", err);
  }
}
async function doPost(
  path,
  params,
  body,
  callback,
  encrypted = false,
  retries = 1,
  callback_error = null
) {
  const url = new URL(api_root + path, base);
  console.log("###doPost###", url);
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );
  //console.log("###doPost###",url)
  let response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: mode, // no-cors, *cors, same-origin
    credentials: "include", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *client
    body: JSON.stringify(body), // body data type must match "Content-Type" header
  });
  if (response.status !== 200 && response.status !== 202) {
    console.log("Error in the petition", response.status);
    throw new Error("Error in the petition");
  }
  let data = await response.json();
  console.log("**post***");
  if (data.error != null) {
    if (data.error === "Session not established") {
      if (retries >= max_retries) {
        console.log("Error in the petition", data.error);
      } else {
        console.log("Error in the petition, retrying", data.error);
        getsecret(() => {
          doPost(path, params, callback, encrypted, ++retries).then();
        });
      }
    } else {
      console.log("Error in the petition", data.error);
      if (callback_error != null) {
        callback_error(data.error);
      }
    }
  } else {
    if (encrypted) {
      try {
        data = decrypt(data, secret);
      } catch (err) {
        if (retries >= max_retries) {
          console.log("Unexpected error max_retries");
        } else {
          getsecret(() => {
            doPost(path, params, callback, encrypted, ++retries).then();
          });
        }
      }
    }
    callback(data);
  }
}

async function doDelete(
  path,
  params,
  callback,
  encrypted = false,
  retries = 1,
  callback_error = null
) {
  const url = new URL(api_root + path, base);
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );
  //console.log("###doDELETE###",url)
  try {
    let response = await fetch(url, {
      method: "DELETE", // *GET, POST, PUT, DELETE, etc.
      mode: mode, // no-cors, *cors, same-origin
      credentials: "include", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *client
    });
    let data = await response.json();
    if (data.error != null) {
      if (data.error === "Session not established") {
        if (retries >= max_retries) {
          console.log("Error in the petition", data.error);
        } else {
          console.log("Error in the petition, retrying", data.error);
          getsecret(() => {
            doDelete(path, params, callback, encrypted, ++retries).then();
          });
        }
      } else {
        console.log("Error in the petition", data.error);
        if (callback_error != null) {
          callback_error(data.error);
        }
      }
    } else {
      if (encrypted) {
        try {
          data = decrypt(data, secret);
        } catch (err) {
          if (retries >= max_retries) {
            console.log("Unexpected error ", err);
          } else {
            secret = undefined;
            getsecret(() => {
              doDelete(path, params, callback, encrypted, ++retries).then();
            });
          }
        }
      }
      callback(data);
    }
  } catch (err) {
    if (err === "Session not established") {
      if (retries >= max_retries) {
        console.log("Unexpected error ");
      } else {
        secret = undefined;
        getsecret(() => {
          doDelete(path, params, callback, encrypted, ++retries).then();
        });
      }
    }
    console.log("Unexpected error ");
  }
}

function getFile(file) {
  const endpoint = `/static/${file}`;
  if (secret === undefined) {
    getsecret(() => {
      doGet(endpoint, undefined, undefined, true);
    });
  } else {
    doGet(endpoint, undefined, undefined, true);
  }
}

export {
  DatesBetween,
  ISO8601_week_no,
  convertToStandard,
  doDelete,
  doGet,
  doPost,
  getFile,
  getWeekDays,
  nextweek,
  parseDate,
};
